import { useCallback } from "react";
import { useQuery } from "@apollo/react-hooks";
import { LIST_MASS_UPLOADS } from "my-documents/graphql/queries/list-mass-uploads";

export const useMassUploadsList = () => {
  const { data, loading, error, refetch } = useQuery(LIST_MASS_UPLOADS, {
    fetchPolicy: "network-only",
  });

  const loadQuery = useCallback(async () => {
    const result = await refetch();
    return result;
  }, [refetch]);

  const massUploads = data?.listMassUploads || [];

  return {
    data: massUploads,
    loading,
    error,
    loadQuery,
  };
};

export default useMassUploadsList;
